import { useQuery } from '@tanstack/react-query';
import { type AxiosResponse } from 'axios';
import { useRouter } from 'next/router';

import { fetchData } from '@framework/api/apiCalls';
import { api } from '@framework/constants/endpoints';
import { STALE_TIME } from '@framework/constants/query';
import { ServerStateKeys } from '@framework/constants/serverStateKeys';

import { type ApiResponse } from '@type/api';
import { type OrganisationUser, type User } from '@type/members';

type Options = {
    enabled?: boolean;
    organisationId?: string;
};

const fetchLoggedUser = async ({ organisationId }: { organisationId?: string }) => {
    const response: AxiosResponse<ApiResponse<User | OrganisationUser>> = await fetchData(
        api.user(),
        {
            params: {
                organisationId
            }
        }
    );

    return response.data.results;
};

const useLoggedUser = (options?: Options) => {
    const router = useRouter();

    const activeOrganisationId =
        options?.organisationId ?? (router?.query?.organisation as string | undefined);

    return useQuery({
        queryKey: [ServerStateKeys.LoggedUser, activeOrganisationId],
        queryFn: () => fetchLoggedUser({ organisationId: activeOrganisationId }),
        staleTime: STALE_TIME,
        ...options
    });
};

export default useLoggedUser;
